export enum IntegrationDataSyncStatus {
  SYNCING = 'SYNCING',
  SYNCED = 'SYNCED',
  SYNC_FAILED = 'SYNC_FAILED',
}
